import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/constants";

export default function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp"
      data-testid="floating-whatsapp"
      className="float-wa pulse-wa"
    >
      <MessageCircle size={26} strokeWidth={2} />
    </a>
  );
}
